import { Footprints } from "lucide-react";
import { CrudPage } from "../components/crud/CrudPage";
import { useOpciones } from "../hooks/useOpciones";
import { Badge } from "../components/ui/Badge";

const estados = ["PROGRAMADO", "EN_PROCESO", "COMPLETADO", "CANCELADO"].map((e) => ({ value: e, label: e.replace("_", " ") }));

export default function Paseos() {
  const { opciones: clientes } = useOpciones("/clientes", (c) => c.nombre);
  const { opciones: mascotas } = useOpciones("/mascotas", (m) => m.nombre);
  const { opciones: paseadores } = useOpciones("/usuarios", (u) => u.nombre, (u) => ["PASEADOR", "ADMIN"].includes(u.rol));

  return (
    <CrudPage
      resource="/paseos"
          seccion="paseos"
      titulo="Paseos"
          icono={<Footprints size={20} />}
      descripcion="Agenda de paseos, rutas y paseadores."
      nombreSingular="paseo"
      campos={[
        { name: "clienteId", label: "Cliente", type: "select", options: clientes, required: true },
        { name: "mascotaId", label: "Mascota", type: "select", options: mascotas, required: true },
        { name: "paseadorId", label: "Paseador", type: "select", options: paseadores },
        { name: "fecha", label: "Fecha", type: "date", required: true },
        { name: "horaInicio", label: "Hora de inicio", placeholder: "10:00", required: true },
        { name: "horaFin", label: "Hora de fin", placeholder: "10:30", required: true },
        { name: "ruta", label: "Ruta" },
        { name: "estado", label: "Estado", type: "select", options: estados },
        { name: "costo", label: "Costo", type: "number" },
      ]}
      columnas={[
        { key: "fecha", label: "Fecha", render: (r: any) => new Date(r.fecha).toLocaleDateString("es-MX") },
        { key: "mascota", label: "Mascota", render: (r: any) => r.mascota?.nombre },
        { key: "horario", label: "Horario", render: (r: any) => `${r.horaInicio} - ${r.horaFin}` },
        { key: "estado", label: "Estado", render: (r: any) => <Badge color="azul">{r.estado}</Badge> },
      ]}
    />
  );
}
